import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import AuthState from "../interfaces/auth/AuthState";

const initialState: AuthState = {
    csrf: null,
    isCaptchaRequired: false,
};

export default function authReducer(state: AuthState = initialState, action: Action) {
    switch (action.type) {
        case ActionTypeEnum.AUTH_LOGIN_BOOTSTRAP_SET:
            return {
                ...state,
                csrf: action.bootstrap.csrf,
                isCaptchaRequired: action.bootstrap.captcha,
            };
        default:
            return state;
    }
}
